/* eslint-disable no-case-declarations */
import {
  BusinessGroupActions,
  GET_MY_BUSINESS_GROUPS,
  SELECT_CURRENT_BUSINESS_GROUPS,
  SELECT_CURRENT_INDOOR
} from "../../types/actions/BusinessGroup.actions";
import { BusinessGroup } from "../../types/models/BusinessGroup";
import { BusinessGroupState } from "../../types/models/BusinessGroupState";
import { IndoorExperience } from "../../types/models/IndoorExperience";

const initialSettings: BusinessGroupState = {
  businessGroups: undefined,
  currentBusinessGroup: undefined,
  currentIndoorExperience: undefined,
  indoorExperiences: undefined
};

const BusinessGroupReducer = (state = initialSettings, action: BusinessGroupActions) => {

  switch (action.type) {
    case GET_MY_BUSINESS_GROUPS:
      const businessGroups: BusinessGroup[] | undefined = action.experiencePayload;
      const indoorExperiences: IndoorExperience[] | undefined = action.indoorPayload;
      return {
        ...state,
        businessGroups: businessGroups,
        indoorExperiences: indoorExperiences
      };
    case SELECT_CURRENT_BUSINESS_GROUPS:
      return {
        ...state,
        currentBusinessGroup: action.payload,
      };
    case SELECT_CURRENT_INDOOR:
      return {
        ...state,
        currentIndoorExperience: action.payload,
      };
    default:
      return state;
  }
};

export default BusinessGroupReducer;
